import React from "react";
import { apiTotalOfficeStockBuild } from "../../services/apis/retail/apiTotalOfficeStockBuild";
import FilterContext from "../../routes/FilterContext";
import { BodyAsFormData } from "../../services/utilities/util";

class TotalOfficeStockBuild extends React.Component {
  static contextType = FilterContext;

  state = {
    sumOfChargeableArea: 0,
    noOfComplexes: 0,
  };

  // componentDidMount() {
  //     apiTotalOfficeStockBuild.post(BodyAsFormData(filters)).then((res) => {
  //         this.setState({ sumOfChargeableArea: res.data.sum_of_chargeable_area, noOfComplexes: res.data.no_of_complxes });
  //     });
  // }

  render() {
    return (
      <div className="widget">
        <div className="row">
          <div className="col-lg-4 flexCenter">
            <img
              alt="Total Office Stock Built Icon"
              src="/edge/images/total_office_stock_built.png"
              className="imgWidth100"
            />
          </div>
          <div className="col-lg-8 text-start colorLightBlue">
            <h1>{this.state.sumOfChargeableArea} msf</h1>
            <p>({this.state.noOfComplexes} assets)</p>
          </div>
        </div>
        <p className="widgetName">Total Office Stock Built</p>
      </div>
    );
  }
}

export default TotalOfficeStockBuild;
